module.exports = __webpack_public_path__ + "static/media/img_46.561546c3.png";